import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20241006 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="10 Października, 2024" header="Nowa wersja 1.3.0" labels={["bugfix", "feature"]}>
      <ChangelogBody title="1.  Dodawanie regulaminu do formularza">
        Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.FORM("1")}>edycji kursu</LinkTo>, w ekranie "Formularz" dodano
        możliwość dodania regulaminu do formularza. Możliwe jest też edytowanie i usuwanie dodanego regulaminu.
      </ChangelogBody>

      <ChangelogBody title="2. Tryb ciemny i poprawki wizualne">
        Poprawiono wygląd aplikacji w trybie ciemnym. Zmieniono kolory przycisków, ikon i innych elementów interfejsu. W
        trybie jasnym również wprowadzono kilka poprawek wizualnych (m.in. wygląd tabeli).
      </ChangelogBody>

      <ChangelogBody title="3. Dostosowanie do urządzeń mobilnych">
        Poprawiono wygląd aplikacji na urządzeniach mobilnych. Zmieniono układ i wygląd niektórych elementów interfejsu.
        Większość funkcjonalności dostępna jest responsywna <br />
        <b className="text-orange-500">{"(disclaimer)"}</b> Kilka funkcjonalności może być niedostępnych na urządzeniach
        mobilnych lub dostosowana w kolejnej wersji.
      </ChangelogBody>

      <ChangelogBody title="4. Poprawka duplikowania kursu">
        Poprawiono błąd, przy duplikowaniu kursu, który powodował, że niektóry wykładowcy nie byli przypisywani do
        harmonogramu w zduplikowanym kursie.
      </ChangelogBody>

      <ChangelogBody title="5. Zmiana dostawcy bazy danych">
        Zmieniono dostawcę bazy danych, co pozwoliło na zwiększenie prędkości działania aplikacji.
      </ChangelogBody>
    </ChangelogArticle>
  );
};
